interface IStoredPromise {
  promise: Promise<any>
  timeMS: number
}

export default class PromiseCache {
  private promiseCache: Map<string, IStoredPromise>

  constructor(private apiRequestFunction: (key: string) => Promise<any>, private maxTTLMS: number = 15 * 60 * 1000) {
    this.promiseCache = new Map()
  }

  public get(key: string): Promise<any> {
    if (this.promiseCache.has(key)) {
      const stored = this.promiseCache.get(key)
      if (stored) {
        const { promise, timeMS } = stored
        const timeNow = Date.now()
        if ((timeMS + this.maxTTLMS) > timeNow) {
          return promise
        } else {
          this.promiseCache.delete(key)
          return this.loadAndStore(key)
        }
      } else {
        this.promiseCache.delete(key)
        return this.loadAndStore(key)
      }
    } else {
      return this.loadAndStore(key)
    }
  }

  private loadAndStore(key: string): Promise<any> {
    const promise = this.apiRequestFunction(key)
    this.promiseCache.set(key, {
      promise,
      timeMS: Date.now()
    })
    return promise
  }
}
